import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {RouterService} from '../RouterService';
import {TranslateService} from '@ngx-translate/core';
import {LanguageHelper} from '../LanguageHelper';

@Component({
    selector: 'app-mobile-sidebar',
    templateUrl: './mobile-sidebar.component.html',
    styleUrls: ['./mobile-sidebar.component.css']
})
export class MobileSidebarComponent implements OnInit {

    readonly DrawerClosedClass: string = 'mobile-sidebar-closed';
    readonly DrawerOpenClass: string = 'mobile-sidebar-open';

    DrawerOpen: boolean;
    DrawerVisibilityClass: string;
    CurrentPage: string;
    CurrentIcon: string;

    selectedLanguage;
    languages;

    constructor(private eRef: ElementRef, private router: Router, private routerService: RouterService, private languageHelper: LanguageHelper) {
        this.DrawerVisibilityClass = this.DrawerClosedClass;
        this.DrawerOpen = false;
        this.languages = languageHelper.getLanguages();
        this.selectedLanguage = languageHelper.getCurrentLang();
    }

    ngOnInit(): void {

    }

    isActiveSite(url: string): string {
        return this.router.isActive(url, true) ? 'mobile-sidebar-link-selected' : '';
    }

    redirect(url): void {
        this.routerService.redirect(url);
    }

    toggleDrawer(close?: boolean): void {
        this.DrawerOpen = !this.DrawerOpen;
        if (close === true) {
            this.DrawerOpen = false;
        }
        if (this.DrawerOpen) {
            this.DrawerVisibilityClass = this.DrawerOpenClass;
        } else {
            this.DrawerVisibilityClass = this.DrawerClosedClass;
        }
    }

    changeLanguage(language): void {
        console.log(language.target.value);
        this.languageHelper.setLanguage(language.target.value);
    }

    @HostListener('document:click', ['$event'])
    clickout(event): void {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.toggleDrawer(true);
        }
    }

}
